import { AccessStrategy } from "src/components/shared-components/enum/enumAccessControl";
import {
  EnvironmentCategory,
  EnvironmentDeviceLockedState,
  EnvironmentState,
  EnvironmentType,
} from "src/components/shared-components/enum/enumEnvironment";
import { ManufacturerSystem } from "src/components/shared-components/enum/enumMisc";
import { Device } from "./device";

/**
 * Handle environment generic object
 */
export class Environment {
  public id: number = 0;
  public instanceGUID: string = "";
  public nRoom: string = "";
  public translatedNRoom: string = "";
  public descriptionEnvironment: string = "";
  public beds: string = "";
  public environmentState = EnvironmentState.OK;
  public isClean: boolean = true;
  public isMinibarOK: boolean = true;
  public reservationCounter: number = 0;
  public environmentType = EnvironmentType.INVISIBLE;
  public gatewayName: string = "";
  public locked = EnvironmentDeviceLockedState.NOT_LOCKED;
  public accessControlManufacturerSystem = ManufacturerSystem.NONE;
  public category = EnvironmentCategory.UNDEFINED;
  public idTimeSlotDefault: number = 0;
  public customDescription: string = "";
  public translatedCustomDescription: string = "";
  public isMaintananceRequire: boolean = false;
  public isRoomAvaiable: boolean = false;
  public notesForCustomer: string = "";
  public instanceGUIDCleaning: string = "";
  public instanceGUIDMinibar: string = "";
  public instanceGUIDMaintenanceRequired: string = "";
  public instanceGUIDRoomAvailable: string = "";
  public addressCleaning: string = "";
  public addressMinibar: string = "";
  public addressMaintenanceRequired: string = "";
  public addressRoomAvailable: string = "";
  public customSetting: string = "";
  public openDoorCommand: string = "";
  public colorStyle: string = "";
  public accessStrategy: AccessStrategy = AccessStrategy.UNKNOWN;
  public cleanFrigoBarAction: number = 0;
  public cleanFrigobar: number = 0;
  public cleanOption: number = 0;
  public cleaningAction: number = 0;
  public customID: number = 0;
  public environmentETSType: number = 4;
  public idRelatedEnvironment: -1;
  public idScenarioOnCheckout: -1;
  public timeSlotEnable: boolean = true;
  public roomAvaiableAction: number = 0;
  public roomAvaiableOption: number = 0;
  public saltoAuthorizationNumber: string = "";
  public tenant: string = "";
  public noteForCustomer: string = "";
  public owner: string = "";
  public maintananceRequiredOption: number = 0;
  public maintananceRquiredAction: number = 0;
  public nCityUp: number = 0;
  public virtualDeviceCount: number;
  public childrenDevices: Device[];
  public thousandths: number = 0;
  public thousandthsHeating: number = 0;
  public idParent: number = 0;
  public removable: boolean = true;
  public hasDevices: boolean = false;
  public sub: string = "";
  public unit: string = "";
  public graphicPage: boolean = false;
  public hasSmartComponent: boolean = false;
  public listAccessControlManufacturerSystems: ManufacturerSystem[] = [];
  public requestConfirmOpenDoor: boolean = false;

  constructor(environment?: any) {
    if (environment) {
      Object.assign(this, environment);
    }
  }
}

/** Class for handling environment with children when building a tree */
export class EnvironmentTree extends Environment {
  public children: EnvironmentTree[] = [];
}
